import { Component, OnInit, Input,ViewChild } from '@angular/core';
import { IStoreMenuCategoryItem } from '../../services/store.service';
import { ModalController } from '@ionic/angular';
//import { ShareService } from '@ngx-share/core';
import { Router } from '@angular/router';
import { IOrderItem } from '../../services/order.service';
import { ShareService } from '../../../shared/services/share.service';

@Component({
    selector: 'app-share-item',
    templateUrl: './share-item.component.html',
    styleUrls: ['./share-item.component.scss'],
    standalone: false
})
export class ShareItemComponent implements OnInit {
  @ViewChild('ref') ref;
  @Input() item: IStoreMenuCategoryItem;
  @Input() orderItem: IOrderItem;
  @Input() total: number;
  listToggle: boolean=false;
  modalToggle: boolean=false;
  givenImages=[
    {id: 1,img: 'https://vex.visurel.com/assets/img/avatars/1.jpg', selected: false},
    {id: 2, img: 'https://vex.visurel.com/assets/img/avatars/2.jpg', selected: false},
    {id: 3, img: 'https://vex.visurel.com/assets/img/avatars/3.jpg', selected: false},
    {id: 4, img: 'https://vex.visurel.com/assets/img/avatars/4.jpg', selected: false}
  ];
  title="boom";
  selectedImages: any[]=[]; //Temp as no database
  constructor(private modalCtrl: ModalController,
    //public share: ShareService,
    public shareService: ShareService,
    private router: Router
    ) { }

  ngOnInit() {
  }
  goToChat()
  {
    this.cancel();
    this.router.navigate(['/chat']);
  }
  cancel() {
    this.modalCtrl.dismiss({
      cancel: true
    });
  }
  toggleList()
  { 
    this.listToggle=true;
  }
  trackClick(e: any)
  { 

    if(this.listToggle)
    {
      if(!e.target.className.includes('unique'))
      {
       this.listToggle=false;
      }
    }
 
  }

  checkboxEvent(e: any, id: any, selected: boolean)
  {

    selected = !selected;
    let target=e.target as HTMLElement;
    let Index=this.givenImages.findIndex(img=> img.id === + id.toString());
    this.givenImages[Index].selected=selected;
    target.classList.add('unique');
    if(selected)
    {
      this.selectedImages.push(this.givenImages.find(img=> img.id === + id.toString()));      
        e.target.value=true;
    }
    else
    {
      this.selectedImages=this.selectedImages.filter(items=> items.id! ==+ id.toString());
      e.target.value=false;
    }
    
  }
  modalToggle2()
  {
    this.modalToggle= !this.modalToggle;
  }
  onModalClick(e)
  {
    if(e.target.className.includes("modal-new-cart"))
    {
      this.modalToggle=false;
    }
  }

  shareItem() {
    
  }

}
